module.exports = __webpack_public_path__ + "static/media/warning.5f794498.svg";